<script setup lang="ts">
defineProps<{
  organization: object|null,
}>()
</script>

<template>
  <SearchCard :avatar="organization?.avatar_url" :to="organization?.url">
    <template #body>
      <p class="font-bold text-lg line-clamp-2 leading-tight" v-if="organization">{{organization.name}}</p>
      <div class="flex-1 overflow-hidden gradient-overlay-bottom" v-if="organization">
        <p class="text-sm"  aria-hidden="true">{{organization.description}}</p>
      </div>
      <div class="text-sm flex flex-row items-center text-gray-500 overflow-hidden gradient-overlay-right" v-if="organization">
              <span class="flex items-center gap-1 flex-shrink-0">
                <UIcon name="i-ph-map-pin-duotone" /> {{organization.location.public_value}}
              </span>
        <span v-if="organization?.domain" class="flex flex-shrink-0">
                <span class="mx-2.5">&bull;</span>
                <span class="flex items-center gap-1">
                  <UIcon :name="getIcon(organization.domain.slug)" /> {{organization.domain.name}}
                </span>
              </span>
      </div>
      <USkeleton class="h-5 w-[70%]" v-if="!organization"/>
      <USkeleton class="h-3 w-[90%]" v-if="!organization"/>
      <USkeleton class="h-3 w-[90%]" v-if="!organization"/>
      <USkeleton class="h-3 w-[60%]" v-if="!organization"/>
      <div class="flex-1"  v-if="!organization"/>
      <USkeleton class="h-3 w-[60%]" v-if="!organization"/>
    </template>
  </SearchCard>
</template>